import { CollectionFunction, CollectionFunctionListData } from 'data/collectionFunction/collectionFunction.types';
import { SupportedFeaturesCollectionFunctions } from 'data/supportedFeatures/supportedFeatures.types';
import { Buffer } from 'buffer';

// sets cfGroup names to each collection function based on collectionFunctionsGroups
export default function adaptCollectionFunctionsToGrid(
  collectionFunctions: CollectionFunction[],
  enabledCollectionFunctions: SupportedFeaturesCollectionFunctions,
): CollectionFunctionListData[] {

  return collectionFunctions.map((currentCollectionFunction) => {
    if (currentCollectionFunction.tag === 'CF-ATIS-0700005') {
      currentCollectionFunction.tag = 'CF-ATIS-1000678';
    }

    return {
      ...currentCollectionFunction,
      decodedId: Buffer.from(currentCollectionFunction.id, 'base64').toString('binary') as string,
      tagName: enabledCollectionFunctions[currentCollectionFunction.tag]?.title || '',
      cfid: interfaceOptionsKeyValue('cfid', currentCollectionFunction) || '',
    };
  });
}

const optionByKey = (key: string) => (option: { key: string, value: string | boolean }) => {
  return option.key === key;
};

const interfaceOptionsKeyValue = (key: string, interfaceEntry: CollectionFunction) => {
  if (interfaceEntry?.hi2Interfaces) {
    return interfaceEntry.hi2Interfaces[0]?.options?.find(optionByKey(key))?.value.toString() || '';
  }
};
